<div class="settings-page w-full h-2/4 overflow-auto zuper-scrollbar bg-white scroll-smooth">
  <!-- header -->
  <div class="border-b border-gray-300 flex justify-between zuper-dialog-header">
    <div class="primary-font font-bold text-2xl text-gray-700 flex items-center pl-2">
      {{ "text.settings" | translate }}
    </div>
  </div>

  <!-- side navbar -->
  <div class="flex flex-wrap w-full overflow-auto zuper-scrollbar dialog">
    <div class="w-20 h-full bg-white border-r border-gray-300">
      <ul>
        <li title="{{'text.dispatchers_queue' | translate}}" *ngIf="display.grid">
          <button class="w-full border-b border-gray-300 border-solid h-20"
            [ngClass]="{ 'tab-icon-selected': moduleName === 'GRID' }" (click)="onTabChange('GRID')">
            <svg id="briefcase" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="currentColor">
              <path fill-rule="evenodd"
                d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                clip-rule="evenodd" />
              <path
                d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
            </svg>
          </button>
        </li>
        <li title="{{'text.users' | translate}}" *ngIf="display.employee">
          <button class="w-full border-b border-gray-300 border-solid h-20"
            [ngClass]="{ 'tab-icon-selected': moduleName === 'EMPLOYEE' }" (click)="onTabChange('EMPLOYEE')">
            <svg id="user" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="currentColor">
              <path fill-rule="evenodd"
                d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </li>
        <li title="{{'dispatchBoard.settings.scheduler.title' | translate}}" *ngIf="display.scheduler">
          <button class="w-full border-b border-gray-300 border-solid h-20"
            [ngClass]="{ 'tab-icon-selected': moduleName === 'SCHEDULER' }" (click)="onTabChange('SCHEDULER')">
            <svg id="calendar" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
              fill="currentColor">
              <path fill-rule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </li>
        <li title="{{'dispatchBoard.settings.map.title' | translate}}" *ngIf="moduleAccess.map && display.map">
          <button class="w-full border-b border-gray-300 border-solid h-20"
            [ngClass]="{ 'tab-icon-selected': moduleName === 'MAP' }" (click)="onTabChange('MAP')">
            <svg id="map" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd"
                d="M8.161 2.58a1.875 1.875 0 011.678 0l4.993 2.498c.106.052.23.052.336 0l3.869-1.935A1.875 1.875 0 0121.75 4.82v12.485c0 .71-.401 1.36-1.037 1.677l-4.875 2.437a1.875 1.875 0 01-1.676 0l-4.994-2.497a.375.375 0 00-.336 0l-3.868 1.935A1.875 1.875 0 012.25 19.18V6.695c0-.71.401-1.36 1.036-1.677l4.875-2.437zM9 6a.75.75 0 01.75.75V15a.75.75 0 01-1.5 0V6.75A.75.75 0 019 6zm6.75 3a.75.75 0 00-1.5 0v8.25a.75.75 0 001.5 0V9z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </li>
      </ul>
    </div>

    <!-- Content -->
    <div *ngIf="isLoading" class="flex items-center justify-center m-auto loader-div">
      <lazy-loader></lazy-loader>
    </div>
    <div class="settingsContent m-auto h-full overflow-auto zuper-scrollbar">

      <!-- GRID -->
      <div *ngIf="!isLoading && moduleName === 'GRID'" class="py-4 px-2 mr-2" #scrollHandler>
        <form [formGroup]="moduleFormMap?.grid">
          <div class="border-b border-gray-300 flex justify-between pb-2">
            <span class="primary-font font-bold text-xl flex items-center">
              {{'text.dispatchers_queue' | translate}}
            </span>
          </div>
          <div class="border-b border-gray-300 flex justify-between py-3">
            <div class="primary-font font-bold text-lg flex items-center">
              <div class="w-3.5 h-3.5 bg-gray-500 mr-2"></div>
              <span class="leading-relaxed text-lg">
                {{'text.primary_color' | translate}} </span>

            </div>
            <div>
              <mat-form-field class="w-40 items-center text-base font-medium text-center text-gray-700 dispatchPicker">
                <mat-select formControlName="primary_color" [disableOptionCentering]="true">
                  <ng-container *ngFor="let option of cardColorOptions">
                    <mat-option [value]="option.value" *ngIf="option.primary"> {{option.label | translate}} </mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="border-b border-gray-300 flex justify-between py-3">
            <div class="primary-font font-bold text-lg flex items-center">
              <div class="w-3.5 h-3.5 bg-gray-500 mr-2 rounded-full"></div>
              <span class="leading-relaxed text-lg">
                {{'text.secondary_color' | translate}} </span>

            </div>
            <div>
              <mat-form-field class="w-40 items-center text-base font-medium text-center text-gray-700 dispatchPicker">
                <mat-select formControlName="secondary_color" [disableOptionCentering]="true">
                  <ng-container *ngFor="let option of cardColorOptions">
                    <mat-option [value]="option.value" *ngIf="option.secondary"> {{option.label | translate}} </mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="border-b border-gray-300 flex justify-between py-3">
            <div class="primary-font font-bold text-lg flex items-center">
              <span class="leading-relaxed text-lg">
                {{'dispatchBoard.settings.grid.job_count' | translate}} </span>
            </div>
            <div>
              <mat-form-field class="w-full items-center text-base font-medium text-center text-gray-700 dispatchPicker">
                <mat-select formControlName="job_count" [disableOptionCentering]="true">
                  <mat-option [value]="option" *ngFor="let option of gridCount"> {{option }} </mat-option>
                </mat-select>
            </mat-form-field>
            </div>
          </div>
          <!-- Details -->
          <div class="pt-3">
            <span class="font-semibold text-xl">{{'details' | translate}}
            </span>
            <p class="pt-1 text-lg">{{'text.choose_job_card.to_see' | translate}}
            </p>
            <div class="mt-3 flex justify-between">
              <div class="space-x-4 space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
                <div class="flex items-center space-x-2">
                  <input id="listView" type="radio" value="listView"
                    class="h-5 w-5 border-gray-300 text-indigo-600 cursor-pointer"
                    formControlName="view_type">
                  <label for="listView"
                    class="block text-lg font-medium leading-6 text-gray-900 cursor-pointer">{{'text.list_view'
                    | translate}}</label>
                </div>
                <div class="flex items-center space-x-2">
                  <input id="tableViewRadio" type="radio" value="tableView"
                    class="h-5 w-5 border-gray-300 text-indigo-600 cursor-pointer"
                    formControlName="view_type">
                  <label for="tableViewRadio"
                    class="block text-lg font-medium leading-6 text-gray-900 cursor-pointer">{{'dispatchBoard.settings.grid.table_view'
                    | translate}}</label>
                </div>
              </div>
              <div class="flex items-center gap-1 h-0"
                *ngIf="moduleFormMap?.grid.get('view_type').value === 'tableView'">
                <span class="text-lg">{{'dispatchBoard.settings.grid.table_view.grid_title' |
                  translate}} </span>
                <mat-form-field class="w-40 items-center text-base font-medium border-transparent cursor-pointer text-gray-700 dispatchPicker">
                  <mat-select formControlName="table_grid_position" [disableOptionCentering]="true">
                    <mat-option [value]="option.value" *ngFor="let option of tablePositionOptions"> {{option.label | translate}} </mat-option>
                  </mat-select>
              </mat-form-field>
              </div>
            </div>

            <!-- Attributes selection -->
            <div class="job-view mt-4">
              <!-- details content for JOB list view -->
              <span class="font-semibold text-xl">
                {{ "dispatchBoard.settings.card_view.job_card" | translate }}
              </span>
              <!-- Card view -->
              <card-details-selector *ngIf="isOptionsAvailable && moduleFormMap?.grid.get('view_type').value === 'listView'" [dispatchTab]="selectedDispatchTab" [sectionType]="'JOB'"
                [module]="'GRID'" [options]="{ MAX_ROW: 5, MAX_COLUMN: 2 }" [triggerChangeDetection]="triggerCardSelectorChangeDetection">
              </card-details-selector>
              <!-- Table view -->
              <div class="w-full pt-2 mb-4" *ngIf="
                  moduleFormMap?.grid.get('view_type').value === 'tableView'
                ">
                <div class="flex justify-between items-center">
                  <span class="leading-relaxed text-lg font-semibold">{{"dispatchBoard.settings.grid.table_view.selected_attributes" | translate }}</span>
                  <mat-form-field appearance="fill" class="w-3/12">
                    <input matInput #tableJobSearch
                      placeholder="{{'text.search_fields' | translate}}" (keyup)="onSearchTableList('JOBS',tableJobSearch.value)">
                    <button *ngIf="tableListSearchSubject.job.value.length" matSuffix mat-icon-button aria-label="Clear"
                      (click)="onSearchTableList('JOBS', ''); tableJobSearch.value=''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
                <div cdkDropList class="attribute-list" (cdkDropListDropped)="drop($event)">
                  <div
                    class="py-3 px-2 border-b border-gray-300 flex flex-row items-center bg-white text-lg box-border gap-3"
                    *ngFor="let attribute of tableViewSelectedAtrributes | listKeywordFilter: tableListSearchKeyword.job: randomNumber" cdkDragLockAxis="y"
                    [cdkDragDisabled]="!attribute.isChecked" cdkDrag cdkDragBoundary=".dialog">
                    <i cdkDragHandle class="ti ti-equal cursor-default drag-handler" [ngClass]="{
                        'drag-handler-block': !attribute.isChecked
                      }"></i>
                    <input [disabled]="!attribute.dismissable" id="{{ attribute.key }}" type="checkbox"
                      [checked]="attribute.isChecked" [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="attribute.isChecked"
                      class="cursor-pointer w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                      (change)="
                        onToggleCheckBox($event.target.checked, attribute)
                      " />
                    <label for="{{ attribute.key }}" class="cursor-pointer select-none">{{ attribute?.displayKeyValue || attribute.label }}</label>
                  </div>
                  <div class="w-full my-1 mx-3" *ngIf="(tableViewSelectedAtrributes | listKeywordFilter: tableListSearchKeyword.job: randomNumber).length === 0  && tableListSearchKeyword.job.length > 0">
                    <span>{{'dispatchBoard.settings.no_attributes_found' | translate}}: '{{tableListSearchKeyword.job}}'</span>
                  </div>
                </div>
                <div class="mt-5">
                  <span id="otherattr" class="leading-relaxed text-lg font-semibold">{{
                    "dispatchBoard.settings.grid.table_view.other_attributes"
                    | translate
                    }}</span>
                  <div class="attribute-list">
                    <div
                      class="py-3 px-2 border-b border-gray-300 flex flex-row items-center bg-white text-lg box-border gap-3"
                      *ngFor="let attribute of tableViewOtherAtrributes | listKeywordFilter: tableListSearchKeyword.job: randomNumber">
                      <input id="{{ attribute.key }}" type="checkbox" [checked]="attribute.isChecked"
                        [ngModelOptions]="{ standalone: true }" [(ngModel)]="attribute.isChecked"
                        [disabled]="tableViewSelectedAttributeCount >= tableViewAttributeMaxCount"
                        [title]="tableViewSelectedAttributeCount >= tableViewAttributeMaxCount ? ('dispatchBoard.settings.grid.table_view.max_attribute_alert' | translate): ''"
                        [ngClass]="{'cursor-not-allowed': tableViewSelectedAttributeCount >= tableViewAttributeMaxCount, 'cursor-pointer': tableViewSelectedAttributeCount < tableViewAttributeMaxCount}"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                        (change)="
                          onToggleCheckBox($event.target.checked, attribute)
                        " />
                      <label for="{{ attribute.key }}" class="cursor-pointer select-none">{{ attribute?.displayKeyValue || attribute.label }}</label>
                    </div>
                    <div class="w-full my-1 mx-3" *ngIf="(tableViewOtherAtrributes | listKeywordFilter: tableListSearchKeyword.job: randomNumber).length === 0 && tableListSearchKeyword.job.length > 0 ">
                      <span>{{'dispatchBoard.settings.no_attributes_found' | translate}}: '{{tableListSearchKeyword.job}}'</span>
                    </div>
                  </div>
                  <div *ngIf="tableViewOtherAtrributes.length === 0 && tableListSearchKeyword.job.length === 0 " class="mt-2 p-5">
                    <span class="text-lg">{{
                      "dispatchBoard.settings.grid.table_view.option_unavailable"
                      | translate
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="route-view mt-4" *ngIf="selectedDispatchTab === 'ROUTES'">
              <!-- details content for ROUTE list view -->
              <span class="font-semibold text-xl">
                {{ "dispatchBoard.settings.card_view.route_card" | translate }}
              </span>
              <p class="pt-1 text-lg">
                {{
                "dispatchBoard.settings.card_view.route_card.subtext"
                | translate
                }}
              </p>
              <!-- Card view -->

              <card-details-selector *ngIf="isOptionsAvailable &&   moduleFormMap?.grid.get('view_type').value === 'listView'" [sectionType]="'ROUTE'" [module]="'GRID'"
                [dispatchTab]="selectedDispatchTab+'second'" [options]="{ MAX_ROW: 5, MAX_COLUMN: 2 }" [triggerChangeDetection]="triggerCardSelectorChangeDetection">
              </card-details-selector>
              <!-- Table view -->
              <div class="w-full pt-2 mb-4" *ngIf="
                  moduleFormMap?.grid.get('view_type').value === 'tableView'">
                <div class="flex justify-between items-center">
                  <span class="leading-relaxed text-lg font-semibold">{{
                    "dispatchBoard.settings.grid.table_view.selected_attributes"
                    | translate
                    }}</span>
                    <mat-form-field appearance="fill" class="w-3/12">
                      <input matInput #tableRouteSearch
                        placeholder="{{'text.search_fields' | translate}}" (keyup)="onSearchTableList('ROUTES',tableRouteSearch.value)">
                      <button *ngIf="tableListSearchSubject.route.value.length" matSuffix mat-icon-button aria-label="Clear"
                        (click)="onSearchTableList('ROUTES', ''); tableRouteSearch.value=''">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                </div>
                <div cdkDropList class="attribute-list" (cdkDropListDropped)="dropRouteViewList($event)">
                  <div
                    class="py-3 px-2 border-b border-gray-300 flex flex-row items-center bg-white text-lg box-border gap-3"
                    *ngFor="let attribute of routeTableViewSelectedAttributes | listKeywordFilter: tableListSearchKeyword.route: randomNumber" cdkDragLockAxis="y"
                    [cdkDragDisabled]="!attribute.isChecked" cdkDrag cdkDragBoundary=".dialog">
                    <i cdkDragHandle class="ti ti-equal cursor-default drag-handler" [ngClass]="{
                        'drag-handler-block': !attribute.isChecked
                      }"></i>
                    <input [disabled]="!attribute.dismissable" id="{{ attribute.key }}" type="checkbox"
                      [checked]="attribute.isChecked" [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="attribute.isChecked"
                      class="cursor-pointer w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                      (change)="
                        onToggleRouteAttributeCheckBox(
                          $event.target.checked,
                          attribute
                        )
                      " />
                    <label for="{{ attribute.key }}" class="cursor-pointer select-none">{{ attribute?.displayKeyValue || attribute.label }}</label>
                  </div>
                  <div class="w-full my-1 mx-3" *ngIf="(routeTableViewSelectedAttributes | listKeywordFilter: tableListSearchKeyword.route: randomNumber).length === 0 && tableListSearchKeyword.route.length > 0">
                    <span>{{'dispatchBoard.settings.no_attributes_found' | translate}}: '{{tableListSearchKeyword.route}}'</span>
                  </div>
                </div>
                <div class="mt-5">
                  <span id="otherattr" class="leading-relaxed text-lg font-semibold">{{
                    "dispatchBoard.settings.grid.table_view.other_attributes"
                    | translate
                    }}</span>
                  <div class="attribute-list">
                    <div
                      class="py-3 px-2 border-b border-gray-300 flex flex-row items-center bg-white text-lg box-border gap-3"
                      *ngFor="let attribute of routeTableViewOtherAtrributes | listKeywordFilter: tableListSearchKeyword.route: randomNumber">
                      <input id="{{ attribute.key }}" type="checkbox" [checked]="attribute.isChecked"
                        [ngModelOptions]="{ standalone: true }" [(ngModel)]="attribute.isChecked"
                        class="cursor-pointer w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                        (change)="
                          onToggleRouteAttributeCheckBox(
                            $event.target.checked,
                            attribute
                          )
                        " />
                      <label for="{{ attribute.key }}" class="cursor-pointer select-none">{{ attribute?.displayKeyValue || attribute.label }}</label>
                    </div>
                    <div class="w-full my-1 mx-3" *ngIf="(routeTableViewOtherAtrributes | listKeywordFilter: tableListSearchKeyword.route: randomNumber).length === 0 && tableListSearchKeyword.route.length > 0">
                      <span>{{'dispatchBoard.settings.no_attributes_found' | translate}}: '{{tableListSearchKeyword.route}}'</span>
                    </div>
                  </div>
                  <div *ngIf="routeTableViewOtherAtrributes.length === 0 && tableListSearchKeyword.route.length === 0" class="mt-2 p-5">
                    <span class="text-lg">{{
                      "dispatchBoard.settings.grid.table_view.option_unavailable"
                      | translate
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- EMPLOYEE -->
      <div *ngIf="moduleName === 'EMPLOYEE' && !isLoading" class="py-4 px-2 mr-2" #scrollHandler>
        <form [formGroup]="moduleFormMap?.employee">
          <div class="border-b border-gray-300 flex justify-between pb-2">
            <span class="primary-font font-bold text-xl flex items-center">
              {{'text.users' | translate}}
            </span>
          </div>
          <div class="border-b border-gray-300 flex justify-between pt-3">
            <div>
              <span class="primary-font font-semibold text-xl flex items-center">
                {{'dispatchBoard.settings.employee.card_details' | translate}}
              </span>
              <p class="font-normal text-lg pt-1">
                {{'dispatchBoard.settings.employee.card_details_subtitle'
                | translate}}</p>
            </div>
            <div class="flex items-center font-normal text-base gap-3 text-black">
              <div class="flex items-center">
                <input id="plain" type="radio" value="plain"
                  class="w-4 h-4 text-blue-600 cursor-pointer bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                  formControlName="profile">
                <label for="plain" class="ml-2 cursor-pointer font-medium dark:text-gray-300">
                  {{'dispatchBoard.settings.employee.option.plain' | translate}}
                </label>
              </div>
              <div class="flex items-center">
                <input id="avatar" type="radio" value="with_avatar"
                  class="w-4 h-4 text-blue-600 cursor-pointer bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                  formControlName="profile">
                <label for="avatar" class="ml-2 dark:text-gray-300 cursor-pointer">
                  {{'dispatchBoard.settings.employee.option.avatar' | translate}}
                </label>
              </div>
            </div>
          </div>

          <!-- Card view -->
          <card-details-selector *ngIf="isOptionsAvailable" [sectionType]="'JOB'" [module]="'EMPLOYEE'"
            [dispatchTab]="selectedDispatchTab" [options]="{ MAX_ROW: 3, MAX_COLUMN: 1 }" [triggerChangeDetection]="triggerCardSelectorChangeDetection">
          </card-details-selector>

          <!-- Display -->
          <div class="w-full">
            <div class="border-b border-gray-300 flex justify-between pt-3">
              <p class="primary-font font-semibold text-xl flex items-center">
                {{'dispatchBoard.settings.employee.more_information' | translate}}
              </p>
            </div>

            <div class="gap-3 w-2/4 flex" formGroupName="more_information">
              <div class="w-2/4">
                <div class="flex items-center py-3 border-b border-gray-300">
                  <input id="skillset" type="checkbox"
                    class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                    formControlName="skillset" />
                  <label for="skillset" class="cursor-pointer select-none">{{
                    "dispatchBoard.settings.employee.more_information.skillset"
                    | translate
                    }}</label>
                </div>

                <div class="flex items-center py-3 border-b border-gray-300">
                  <input id="role" type="checkbox"
                    class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                    formControlName="role" />
                  <label for="role" class="cursor-pointer select-none">{{
                    "role.text"
                    | translate
                    }}</label>
                </div>

                <div class="flex items-center py-3 border-b border-gray-300">
                  <input id="capacity" type="checkbox"
                    class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                    formControlName="capacity" />
                  <label for="capacity" class="cursor-pointer select-none">{{
                    "dispatchBoard.settings.employee.more_information.capacity"
                    | translate
                    }}</label>
                </div>
              </div>

              <div class="w-2/4">
                <div class="flex items-center py-3 border-b border-gray-300">
                  <input id="work_hours" type="checkbox"
                    class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                    formControlName="work_hours" />
                  <label for="work_hours" class="cursor-pointer select-none">{{
                    "text.work_hours"
                    | translate
                    }}</label>
                </div>

                <!-- <div class="flex items-center py-3 border-b border-gray-300">
                  <input id="timesheet_status" type="checkbox"
                    class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                    formControlName="timesheet_status" />
                  <label for="timesheet_status" class="cursor-pointer select-none">{{
                    "dispatchBoard.settings.employee.more_information.timesheet_status"
                    | translate
                    }}</label>
                </div> -->
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- SCHEDULER -->
      <div *ngIf="moduleName === 'SCHEDULER' && !isLoading" class="py-4 px-2 mr-2" #scrollHandler>
        <form [formGroup]="moduleFormMap?.scheduler">
          <div class="border-b border-gray-300 flex justify-between pb-2">
            <span class="primary-font font-bold text-xl flex items-center">
              {{'dispatchBoard.settings.scheduler.title' | translate}}
            </span>
          </div>
          <div class="border-b border-gray-300 flex justify-between pt-3">
            <span class="primary-font font-semibold text-xl flex items-center">
              {{'dispatchBoard.settings.scheduler.job_card_info' | translate}}
            </span>
          </div>
          <div class="border-b border-gray-300 flex justify-between py-3">
            <div class="primary-font text-lg grid">
              <span class="leading-relaxed font-bold text-lg">
                {{'text.primary_color' | translate}} </span>
              <span class="font-normal text-lg">{{'dispatchBoard.settings.scheduler.primary_color_subtitle'| translate}}</span>
            </div>
            <div class="flex space-x-2 items-center">
              <mat-form-field class="w-40 items-center text-base font-medium text-center text-gray-700 dispatchPicker">
                <mat-select formControlName="primary_color" [disableOptionCentering]="true" (change)="schedulerPrimaryColor.blur()" #schedulerPrimaryColor>
                  <ng-container *ngFor="let option of cardColorOptions">
                    <mat-option [value]="option.value" *ngIf="option.primary"> {{option.label | translate}} </mat-option>
                  </ng-container>
                  <mat-option [value]="'custom'"> {{'dispatchBoard.settings.scheduler.custom_colours' | translate}} </mat-option>
                  <hr>
                  <div class="row no-gutters pb-1">
                    <div class="flex space-x-2 items-center text-right p-2 pl-4 hover:bg-gray-100 text-base font-medium cursor-pointer"
                    (click)="openColorProfileDrawer()">
                      <span class="text-blue">Custom</span>
                      <i class="ti ti-arrow-right text-2xl text-blue"></i>
                    </div>
                  </div>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="border-b border-gray-300 flex justify-between py-3">
            <div class="primary-font text-lg grid">
              <span class="leading-relaxed font-bold text-lg">
                {{'text.secondary_color' | translate}} </span>
              <span class="font-normal text-lg">{{'dispatchBoard.settings.scheduler.secondary_color_subtitle'
                | translate}}</span>
            </div>
            <div>
              <mat-form-field class="w-40 items-center text-base font-medium text-center text-gray-700 dispatchPicker">
                <mat-select formControlName="secondary_color" [disableOptionCentering]="true">
                  <ng-container *ngFor="let option of cardColorOptions">
                    <mat-option [value]="option.value" *ngIf="option.secondary"> {{option.label | translate}} </mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>

            </div>
          </div>
          <!-- Details -->
          <div class="pt-3">
            <span class="font-bold text-lg">{{'details' | translate}}
            </span>
            <p class="pt-1 font-normal text-lg">{{'text.choose_job_card.to_see' |
              translate}}
            </p>

            <!-- Card view -->
            <card-details-selector *ngIf="isOptionsAvailable" [sectionType]="'JOB'" [module]="'SCHEDULER'"
              [dispatchTab]="selectedDispatchTab" [options]="{'MAX_ROW': 5, 'MAX_COLUMN': 2}" [triggerChangeDetection]="triggerCardSelectorChangeDetection">
            </card-details-selector>

          </div>

          <!-- Display -->
          <div class="w-full">
            <div class="border-b border-gray-300 flex justify-between pt-3">
              <p class="primary-font font-semibold text-xl flex items-center">
                {{'dispatchBoard.settings.scheduler.display_title' | translate}}
              </p>
            </div>

            <!-- Mode of Transport -->
            <div class="flex justify-between w-full pt-3" *ngIf="_utilityService.companyPolicy.dispatch_board.distance_time && selectedDispatchTab === 'JOBS' && moduleFormMap.scheduler.get('display').value.duration_between_jobs">
              <label for="mode_of_transport"
              class="select-none">{{'text.mode_of_transport' | translate}}</label>
              <mat-form-field class="w-40 items-center text-base font-medium text-center text-gray-700 dispatchPicker">
                <mat-select formControlName="mode_of_transport" [disableOptionCentering]="true">
                  <mat-option [value]="option.value" *ngFor="let option of modeOfTransportOptions"> {{option.label | translate }} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="gap-3" formGroupName="display">
              <!-- <div class="flex items-center py-3 border-b border-gray-300">
                <input id="multiple_teams" type="checkbox" formControlName="multiple_teams"
                  class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
                <label for="multiple_teams"
                  class="cursor-pointer select-none">{{'dispatchBoard.settings.scheduler.display.multiple_teams'
                  | translate}}</label>
              </div> -->

              <div class="flex items-center py-3 border-b border-gray-300" *ngIf="_utilityService.companyPolicy.dispatch_board.distance_time && selectedDispatchTab === 'JOBS'">
                <input id="duration_between_jobs" type="checkbox" formControlName="duration_between_jobs"
                  class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
                <label for="duration_between_jobs"
                  class="cursor-pointer select-none">{{'dispatchBoard.settings.scheduler.display.duration_between_jobs'
                  | translate}}</label>
              </div>

              <div class="flex items-center py-3 border-b border-gray-300">
                <input id="business_hours_only" type="checkbox" formControlName="business_hours_only"
                  class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
                <label for="business_hours_only"
                  class="cursor-pointer select-none">{{'dispatchBoard.settings.scheduler.display.business_hours_only'
                  | translate}}</label>
              </div>
              <div class="flex items-center py-3 border-b border-gray-300">
                <input id="job_summary" type="checkbox" formControlName="job_summary"
                  class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
                <label for="job_summary"
                  class="cursor-pointer select-none">{{(selectedDispatchTab === 'JOBS'? 'text.job_summary': 'text.route_summary') | translate}}</label>
              </div>

              <div class="flex items-center py-3 border-b border-gray-300">
                <input id="weekends" type="checkbox" formControlName="weekends"
                  class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
                <label for="weekends"
                  class="cursor-pointer select-none">{{'dispatchBoard.settings.scheduler.display.weekends'
                  | translate}}</label>
              </div>

              <div class="flex items-center py-3 border-b border-gray-300">
                <input id="week_numbers" type="checkbox" formControlName="week_numbers"
                  class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
                <label for="week_numbers"
                  class="cursor-pointer select-none">{{'dispatchBoard.settings.scheduler.display.week_numbers'
                  | translate}}</label>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- MAP -->
      <div *ngIf="moduleName === 'MAP' && !isLoading && moduleAccess.map" class="py-4 px-2 mr-2" #scrollHandler>
        <form [formGroup]="moduleFormMap?.map">
          <div class="border-b border-gray-300 flex justify-between pb-2">
            <span class="primary-font font-bold text-xl flex items-center">
              {{'dispatchBoard.settings.map.title' | translate}}
            </span>
          </div>
          <div class="border-b border-gray-300 flex items-center py-3 justify-between">
            <div class="flex items-center gap-3">
              <input id="enable_map_view" type="checkbox"
                class="cursor-pointer w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                formControlName="enable_map_view">
              <label for="enable_map_view" class="cursor-pointer select-none">{{'dispatchBoard.settings.map.enable_map'
                | translate}}</label>
            </div>
            <div class="flex space-x-2 items-center text-blue text-base font-medium cursor-pointer"
              (click)="openColorProfileDrawer()">
              <span>{{'dispatchBoard.settings.scheduler.custom_colours_and_icons' | translate}}</span>
              <i class="ti ti-arrow-right text-2xl"></i>
            </div>
          </div>
          <div class="flex items-center gap-3 py-3 border-gray-300 border-b" *ngIf="moduleFormMap?.map.value.enable_map_view">
            <input id="nearby_jobs" type="checkbox"
              class="cursor-pointer w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
              formControlName="nearby_jobs">
            <label for="nearby_jobs" class="cursor-pointer select-none">{{'dispatchBoard.settings.map.enable_nearby_jobs'|
              translate}}</label>
          </div>
          <div formGroupName="layers" *ngIf="moduleFormMap?.map.value.enable_map_view">
            <div class="border-b border-gray-300 flex justify-between pt-2">
              <span class="primary-font font-semibold text-xl flex items-center">{{
                'text.default_layers' | translate}}</span>
            </div>

            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="jobs" type="checkbox"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                formControlName="jobs">
              <label for="jobs" class="cursor-pointer select-none">{{'text.jobs'
                | translate}}</label>
            </div>

            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="routes" type="checkbox"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                formControlName="routes">
              <label for="routes"
                class="cursor-pointer select-none">{{'text.routes'
                | translate}}</label>
            </div>

            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="users" type="checkbox"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                formControlName="users">
              <label for="users" class="cursor-pointer select-none">{{'text.users'
                | translate}}</label>
            </div>

            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="customers" type="checkbox"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                formControlName="customers">
              <label for="customers" class="cursor-pointer select-none">{{'customers.text'
                | translate}}</label>
            </div>

            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="properties" type="checkbox"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                formControlName="properties">
              <label for="properties"
                class="cursor-pointer select-none">{{'text.properties'
                | translate}}</label>
            </div>

            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="assets" type="checkbox"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                formControlName="assets">
              <label for="assets"
                class="cursor-pointer select-none">{{'text.assets'
                | translate}}</label>
            </div>
            
            <div class="flex items-center py-3 border-b border-gray-300">
              <input id="service_territories" type="checkbox"
                class="cursor-pointer w-4 h-4 mr-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                formControlName="service_territories">
              <label for="service_territories"
                class="cursor-pointer select-none">{{'text.service_territories'
                | translate}}</label>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- footer -->
  <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
    <div class="flex justify-around space-x-4">
      <button type="button" (click)="closeSettingsDialog()"
        class="px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-gray-700 font-small rounded-md text-white-600 focus:outline-none btn-small">
        {{'cancel.text' | translate}}</button>
      <button type="submit" (click)="onSubmit()"
        class="bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-small rounded-md text-white-600 focus:outline-none btn-small"
        type="submit">{{'text.save' | translate}}</button>
    </div>
  </div>
</div>